"use client";

import { Fragment, useCallback, useEffect, useRef, useState } from "react";

import StepContainer from "../../../components/new_components/StepContainer";
import { BottomSheet } from "../../../components/new_components/BottomSheet";
import { WarningAlert } from "../../../components/alerts/warningAlert";
import { InfoAlert } from "../../../components/alerts/infoAlert";
import { ReactComponent as KeyIcon } from "./../../../public/svg/Key.svg";
import { ReactComponent as FilesIcon } from "./../../../public/svg/Files.svg";
import { HttpRequest } from "../../../services/httpRequest";
import { ProgressLinear } from "../../../components/progress/progressLinear";
import { useNavigate } from "react-router-dom";
import { montoElegido, otpResultado, trackEvent, trackEventOnce } from "../../../services/analytics/track";
import { ErrorAlert } from "../../../components/alerts/errorAlert";
import OtpComponente from "../../../components/new_components/Otp";
import { ContractFirmaElectronicaV3 } from "../../../components/new_components/Agreements/ContractFirmaElectronicaV1";
import { creditOfferStore } from "../../../store/creditStore/offerCreditStore";
import { useCreditStore } from "../../../store/creditStore/creditUserStore";
import { returnToSignin } from "../../../utils/returnToSign";
import AnimationComponent from "../../../components/new_components/animation";
import { ReactComponent as GalileIcon } from "../../../public/logos/galilea-icono.svg";
import { userBankStore } from "../../../store/creditStore/userBankStore";
import { stepsCreditStore } from "../../../store/creditStore/stepsCreditStore";
import {
  getPostbackContext,
  storeUtmSettlement,
} from "../../../services/utmleads/utmReferral";
import { VeriffPageCredit } from "./veriff/VeriffPageCredit";
import { VeriffService } from "../../../services/veriff/veriff.service";
import { Camera, IdCard } from "lucide-react";
import { ArrowRightIcon } from "@heroicons/react/24/solid";
import { CreditsService } from "../../../services/credits/credits.service";
import { CreditStatusEnum } from "../../../constants/CreditStatusEnum";
import { APIClient } from "../../../helpers/api_helper";
import { SettingAuthSupplierEnum } from "../../../utils/settings.interface";
import {
  GET_SETTING_BY_NAME,
  GET_USER_BYDOC,
} from "../../../helpers/url_helper";
import { useMobileDetection } from "../../../hooks/use-mobile-detection";

const urlCrezu = "https://track.leadbazaar.co/click?pid=6180&offer_id=389";
const apiClient = new APIClient();

const DatosOtp = ({
  onStepChange,
  stepTitlesGeneral,
  currentStepGeneral,
  isDesktop,
  currentStep: parentStep,
}) => {
  const INITIAL_TIME = 3 * 60;
  const TIMER_KEY = "veriffPendingEndTime";
  const [timeLeft, setTimeLeft] = useState(INITIAL_TIME);
  const navigate = useNavigate();
  const { isMobile, screenWidth, screenHeight } = useMobileDetection();

  const { offerCreditStore, loadOfertCredit, clearOfertCredit } =
    creditOfferStore();
  const { creditUserStore, loadUser, clearUser } = useCreditStore();
  const { clearUserBank } = userBankStore();
  const { clearSteps, saveSteps } = stepsCreditStore();

  const phone = localStorage.getItem("phone");
  const celularProtect = "********" + phone.substring(8);

  const [currentStep, setCurrentStep] = useState(1);
  const [currentText] = useState("Iniciar verificación");
  const [isLoading, setIsLoading] = useState(false);
  const [dialogOpenContratoFirma, setDialogOpenContratoFirma] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const [isError] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);

  const [messsageAlert, setMessageAlert] = useState("");
  const [alertSession, setAlertSession] = useState(false);
  const [isOpenWarning, setIsOpenWarning] = useState(false);
  const [isOpenError, setIsOpenError] = useState(false);

  const [isOpenInfo, setIsOpenInfo] = useState(false);

  const [viewProgress, setViewProgress] = useState(false);

  const [isTransitioning, setIsTransitioning] = useState(false);
  const [viewButton, setViewButton] = useState(true);
  const [formDataOtp, setFormDataOtp] = useState({
    otp: "",
  });

  const [isNotApprovedVeriff, setIsNotApprovedVeriff] = useState(false);
  const [isApprovedVeriff, setIsApprovedVeriff] = useState(false);
  const [veriffStatus, setVeriffStatus] = useState("idle"); // 'idle' | 'loading_session' | 'ready' | 'error' | 'submitted'
  const [, setErrorMsg] = useState("");
  const [reason, setReason] = useState("");

  const [errors, setErrors] = useState({});
  const [isDesktopReize, setIsDesktopReize] = useState(false);
  const [url] = useState(urlCrezu);
  const [settingAuths, setSettingAuths] = useState([]);
  const [userAuth, setUserAuth] = useState([]);
  const [textIndex, setTextIndex] = useState(0);

  const stepTitles = [
    isDesktop ? "Verifica tu identidad" : "Firmar Documentos.",
    isDesktop
      ? "Te enviamos el código OTP a tu WhatsApp."
      : "Firmar Documentos.",
  ];
  const stepSubTitles = [
    `Para garantizar la seguridad de tus transacciones y cumplir con las regulaciones vigentes, Galilea utiliza Veriff para realizar una verificación de identidad rápida y segura. Necesitarás tu documento de identidad y un dispositivo con cámara.`,
    `Escribe el código de ó dígitos que te envíamos a tu celular registrado +57 ${celularProtect}`,
  ];

  const texts = [
    "Estamos procesando la validación de tus datos y con la información de nuestras bases de datos...",
    "Esto suele tardar menos de 3 minutos. Por favor no cierres esta página...",
  ];

  const pollingIntervalRef = useRef(null);
  const attemptsRef = useRef(0);
  const maxAttempts = 36; // 36 attempts * 5 seconds = 180 seconds (3 minutes)

  const totalSteps = stepTitles.length;

  const handleToggleDialogContratoFirma = () => {
    if (dialogOpenContratoFirma) {
      setDialogOpenContratoFirma(false);
    } else {
      setDialogOpenContratoFirma(true);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormDataOtp((prev) => ({ ...prev, [name]: value }));

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
    setIsDisabled(false);
  };

  const handleProgress = (isView) => {
    setViewProgress(isView);
  };

  const resendCodeSignature = useCallback(async () => {
    setDisableButton(true);

    let data = {
      doc: localStorage.getItem("doc"),
      phone: phone,
      credit_id: localStorage.getItem("credit_id"),
    };
    try {
      //const responseService = await HttpRequest.aceptarPagare(data);
      const responseService = await HttpRequest.requestSignature(data);
      if (responseService.error) {
        handleProgress(false);
        clearAlert();
        handleOpenAlert(
          "error",
          "Ups!, no pudimos enviar el código, intenta nuevamente!",
          true,
        );
        setDisableButton(false);
        return;
      }
      handleOpenAlert("success", "Código enviado exitosamente!!", true);
      setTimeout(() => {
        setDisableButton(false);
      }, 5000);
    } catch (error) {
      console.log(error);
      handleOpenAlert("error", error, true);
    }
  }, [phone]);

  const cleanIndexDB = () => {
    clearUser();
    clearUserBank();
    clearOfertCredit();
    clearSteps();
    localStorage.clear();
  };

  const validateStep = (step) => {
    const newErrors = {};

    switch (step) {
      case 1:
        if (!formDataOtp.otp || formDataOtp.otp.length !== 6) {
          newErrors.otp = "El código debe tener exactamente 6 dígitos.";
          return;
        }
        if (!/^\d{6}$/.test(formDataOtp.otp)) {
          newErrors.otp = "El código solo puede contener números.";
          return;
        }
        break;
      default:
        break;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = () => {
    if (currentStep === totalSteps) {
      if (validateStep(currentStep)) {
        handleSubmit();
      }
    } else {
      if (currentStep === 1) {
        handleStartVerification();
        return;
      }
      setCurrentStep((prev) => prev + 1);
      return;
    }
  };

  const handlePrevGeneral = () => {
    if (currentStep > 1) {
      setTimeout(() => {
        onStepChange(parentStep - 1);
      }, 150);
    }
  };

  const handlePrev = () => {
    if (currentStep === 1) {
      handlePrevGeneral();
      return;
    }
    if (currentStep > 1) {
      setIsDisabled(false);
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentStep((prev) => prev - 1);
        setIsTransitioning(false);
      }, 150);
    }
  };

  const clearAlert = () => {
    setMessageAlert("");
    setAlertSession(false);
    setIsOpenInfo(false);
    setIsOpenWarning(false);
    setIsOpenError(false);
  };

  const hasActiveCredit = async () => {
    try {
      let response = await HttpRequest.hasActiveCredit(
        localStorage.getItem("doc"),
      );
      return response.message.info;
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmit = async () => {
    handleProgress(true);
    setIsLoading(true);
    let data = {
      doc: localStorage.getItem("doc"),
      idCredit: localStorage.getItem("credit_id"),
      token: formDataOtp.otp,
      postbackContext: getPostbackContext(),
    };
    try {
      /* console.log('Data enviada: ', data); */
      let hasActive = await hasActiveCredit();
      if (hasActive) {
        handleOpenAlert(
          "error",
          "No es posible llevar a cabo la firma, ya usted posee un crédito en estado Vigente.",
          true,
        );
        return;
      }
      const responseService = await HttpRequest.validateOtpSignature(data);
      trackEvent("otp_verificado", { contexto: "firma", resultado: otpResultado(responseService) });
      if (responseService.error) {
        if (
          responseService.message.code === "INVALIDTOKEN" ||
          responseService.message.code === 411
        ) {
          handleOpenAlert("error", "Token inválido", true);
          handleProgress(false);
          setIsLoading(false);
          setTimeout(() => {
            navigate("/");
          }, 3000);
          return;
        }
        handleProgress(false);
        setIsLoading(false);
        handleOpenAlert("error", responseService?.message?.message, true);
      } else {
        storeUtmSettlement(responseService.message);
        trackEvent("credito_firmado", {
          revenue: montoElegido(offerCreditStore),
          currency: "COP",
          plazo_dias: offerCreditStore?.termInDays,
          tipo_cliente: "nuevo",
        });
        if (onStepChange) {
          onStepChange(parentStep + 1); // o el número de paso que desees
        }
        handleProgress(false);
        setIsLoading(false);
        localStorage.setItem("is_signin", true);
        return;
      }
    } catch (error) {
      handleProgress(false);
      setIsLoading(false);
      console.log(error);
      handleOpenAlert(
        "error",
        "Ocurrió un error inesperado, intenta mas tarde",
        true,
      );
      setTimeout(() => {
        returnToSignin(navigate);
      }, 5000);
    }
  };

  const handleOpenAlert = (type, message, isOpen) => {
    if (type === "warning") {
      setMessageAlert(message);
      setAlertSession(isOpen);
      setIsOpenWarning(isOpen);

      setTimeout(() => {
        setMessageAlert("");
        setAlertSession(!isOpen);
        setIsOpenWarning(!isOpen);
      }, 6000);
    }

    if (type === "error") {
      setMessageAlert(message);
      setAlertSession(isOpen);
      setIsOpenError(isOpen);

      setTimeout(() => {
        setMessageAlert("");
        setAlertSession(!isOpen);
        setIsOpenError(!isOpen);
      }, 8000);
    }
  };

  const startPolling = () => {
    pollingIntervalRef.current = setInterval(async () => {
      attemptsRef.current += 1;

      if (attemptsRef.current >= maxAttempts) {
        setVeriffStatus("TIMEOUT");
        if (pollingIntervalRef.current) {
          clearInterval(pollingIntervalRef.current);
        }
        return;
      }

      await fetchVerificationStatus();
    }, 5000); // Poll every 5 seconds
  };

  const fetchVerificationStatus = async () => {
    try {
      const response = await VeriffService.getStatus();
      const backendStatus = response?.status; // PENDING, APPROVED, DECLINED
      if (backendStatus === "APPROVED" || backendStatus === "DECLINED") {
        trackEventOnce(`identidad-${backendStatus}`, "identidad_verificada", {
          resultado: backendStatus === "APPROVED" ? "aprobada" : "rechazada",
        });
      }

      if (backendStatus === "APPROVED") {
        setIsApprovedVeriff(true);
        setTimeout(() => {
          setCurrentStep((prev) => prev + 1);
          setIsApprovedVeriff(false);
        }, 5000);
        setVeriffStatus("APPROVED");
        if (pollingIntervalRef.current)
          clearInterval(pollingIntervalRef.current);
      } else if (backendStatus === "DECLINED") {
        setVeriffStatus("DECLINED");
        setReason("Discrepancia en la validación de identidad.");
        await rechazeFlowCredit();
        if (pollingIntervalRef.current)
          clearInterval(pollingIntervalRef.current);
      } else if (backendStatus === "PENDING") {
        setVeriffStatus("PENDING");
        // Start polling if not already started
        if (!pollingIntervalRef.current) {
          startPolling();
        }
      } else {
        // Fallback for unexpected backend responses
        setVeriffStatus("PENDING");
        if (!pollingIntervalRef.current) {
          startPolling();
        }
      }
    } catch (error) {
      console.error("Error fetching Veriff status:", error);
      // In case of API failure (network issue, etc.), we don't break immediately, just let polling retry
      if (!pollingIntervalRef.current) {
        setVeriffStatus("PENDING");
        startPolling();
      }
    }
  };

  const handleVeriffStatus = (status) => {
    switch (status) {
      case "idle":
      case "loading_session":
      case "error":
      case "ready":
        break;

      case "submitted":
      case "SUBMITTED":
      case "FINISHED":
        fetchVerificationStatus();

        break;

      default:
        break;
    }
  };

  const handleStartVerification = async () => {
    trackEvent("identidad_iniciada", {});
    setVeriffStatus("loading_session");

    setErrorMsg("");
    try {
      const response = await VeriffService.createSession();
      if (response.status === "success" && response.verification) {
        const { url } = response.verification;

        // Use Veriff InContext SDK directly to open the modal overlay
        if (window.veriffSDK) {
          window.veriffSDK.createVeriffFrame({
            url: url,
            onEvent: function (msg) {
              console.log("Veriff event received:", msg);
              if (msg === "FINISHED" || msg === "SUBMITTED") {
                // navigate("/veriff-status");
                setVeriffStatus(msg);
              } else if (msg === "CANCELED") {
                setVeriffStatus(msg);
              }
            },
          });
          setVeriffStatus("ready");
        } else {
          throw new Error(
            "El SDK de Veriff no cargó correctamente. Por favor recarga la página.",
          );
        }
      } else {
        throw new Error("No se pudo iniciar la sesión de verificación.");
      }
    } catch (error) {
      console.error("Error initiating Veriff:", error);
      setVeriffStatus("error");
      setErrorMsg(
        error.response?.data?.message ||
        error.message ||
        "No se pudo iniciar la sesión de verificación. Inténtalo de nuevo.",
      );
    }
  };

  const rechazeFlowCredit = async () => {
    const payload = {};
    Object.assign(payload, {
      documento: localStorage.getItem("doc"),
      fullname: `${creditUserStore.firstname} ${creditUserStore.firstlastname}`,
      email: localStorage.getItem("email"),
      phone: localStorage.getItem("phone"),
      causaRestriccion: reason,
    });
    const responseService = await HttpRequest.restrictionListGalilea(payload);
    const responseServiceUflow =
      await HttpRequest.restrictionListUflow(payload);
    if (
      responseService.message.success === true &&
      responseServiceUflow.message.success === true
    ) {
      setIsNotApprovedVeriff(true);
      updateCredit();
      deleteUser();
    }
  };

  const updateCredit = async () => {
    const { data } = await HttpRequest.getCreditById(
      localStorage.getItem("credit_id"),
    );

    try {
      await CreditsService.updateCreditFromOfferPage({
        credit: {
          ...data,
          status: CreditStatusEnum.SR,
        },
        creditId: localStorage.getItem("credit_id"),
        documento: localStorage.getItem("doc"),
      });
    } catch (error) {
      console.log("Error al actualizar el credito");
      console.log(error);
    }
  };

  const deleteUser = async () => {
    try {
      await HttpRequest.deleteUser({
        documento: localStorage.getItem("doc"),
      });
    } catch (error) {
      console.log("Error al actualizar el credito");
      console.log(error);
    }
  };

  const getFormHeight = () => {
    if (screenHeight <= 490) return "200px";
    if (screenHeight <= 500) return "210px";
    if (screenHeight <= 575) return "230px";
    if (screenHeight <= 599) return "240px";
    if (screenHeight <= 610) return "260px";
    if (screenHeight <= 650) return "300px";
    if (screenHeight <= 699) return "320px";
    if (screenHeight <= 710) return "340px";
    if (screenHeight <= 750) return "360px";
    if (screenHeight <= 799) return "440px";
    if (screenHeight <= 810) return "430px";
    if (screenHeight <= 850) return "490px";
    if (screenHeight <= 899) return "500px";
    if (screenHeight <= 910) return "460px";
    if (screenHeight <= 950) return "540px";
    if (screenHeight <= 999) return "580px";
    if (screenHeight <= 1000) return "520px";
    if (screenHeight > 1001) return "830px";
    return "820px";
  };

  const getFormHeightAndWidth = () => {
    if (screenWidth <= 1200) return "w-72 h-36";
    if (screenWidth <= 1360) return "w-72 h-36";
    if (screenWidth <= 1536) return "w-60 h-28";
    if (screenWidth > 1536) return "w-96 h-52";
    return "w-96 h-52";
  };

  const getHeight = () => {
    if (screenWidth <= 1200) return "clamp(25rem,60vh,45rem)";
    if (screenWidth <= 1360) return "clamp(25rem,60vh,45rem)";
    if (screenWidth <= 1536) return "clamp(25rem,60vh,45rem)";
    if (screenWidth > 1536) return "clamp(16rem, 29vh, 27rem)";
    return "clamp(16rem, 29vh, 27rem)";
  };

  const getContainerHeight = () => {
    if (screenWidth <= 1200) return "15rem";
    if (screenWidth <= 1360) return "clamp(10rem,20vh,35rem)";
    if (screenWidth <= 1536) return "clamp(10rem,20vh,35rem)";
    if (screenWidth > 1536) return "";
    return "";
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;

    return `${minutes}:${secs.toString().padStart(2, "0")}`;
  };

  useEffect(() => {
    if (veriffStatus) {
      setTimeout(() => {
        handleVeriffStatus(veriffStatus);
      }, 150);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- handleVeriffStatus intentionally omitted: it chains into fetchVerificationStatus -> rechazeFlowCredit/startPolling -> updateCredit/deleteUser, an unmemoized multi-level async chain closing over 'reason' and 'creditUserStore' in the KYC/credit-rejection flow; memoizing the whole chain is deferred to avoid risk of stale closures or duplicate rejection/polling calls.
  }, [veriffStatus]);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.veriff.me/incontext/js/v1/veriff.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      try {
        document.body.removeChild(script);
      } catch (e) {
        console.warn("Could not remove Veriff SDK script", e);
      }
    };
  }, []);

  useEffect(() => {
    const veriffStatusStorage = localStorage.getItem("veriffStatus");
    if (veriffStatusStorage === "APPROVED") {
      setCurrentStep(2);
      return;
    } else {
      if (settingAuths) {
        for (let index = 0; index < settingAuths.length; index++) {
          const settingAuth = settingAuths[index];
          if (
            settingAuth.supplier === SettingAuthSupplierEnum.AUTH_VERIFF &&
            settingAuth.active &&
            userAuth.shouldRequestAuthKyc
          ) {
            setCurrentStep(1);
            return;
          } else {
            setCurrentStep(2);
            return;
          }
        }
      }
    }
  }, [settingAuths, userAuth.shouldRequestAuthKyc]);

  useEffect(() => {
    const fetchKycs = async () => {
      try {
        let { data } = await apiClient.get(GET_SETTING_BY_NAME, {
          name: "auth-kyc",
        });

        let documento = localStorage.getItem("doc");
        let user = await apiClient.get(`${GET_USER_BYDOC}/${documento}`);

        setUserAuth(user?.data.userData ?? []);
        setSettingAuths(data?.data.value ?? []);
      } catch (error) {
        console.error("Error al cargar bancos tokenizados:", error);
        setSettingAuths([]);
      }
    };

    fetchKycs();
  }, []);

  useEffect(() => {
    if (currentStep === 2) {
      try {
        resendCodeSignature();
        clearAlert();
      } catch (error) {
        console.log(error);
      }
    }
  }, [currentStep, resendCodeSignature]);

  useEffect(() => {
    const TIMER_KEY = "veriffPendingEndTime";
    if (veriffStatus !== "PENDING") return;

    let endTime = localStorage.getItem(TIMER_KEY);

    if (!endTime) {
      localStorage.setItem(TIMER_KEY, INITIAL_TIME);
      setTimeLeft(INITIAL_TIME);
    } else {
      setTimeLeft(endTime);
    }

    setViewButton(false);
    // Cambia los textos cada 5 segundos
    const textInterval = setInterval(() => {
      setTextIndex((prev) => (prev + 1) % texts.length);
    }, 5000);

    // Countdown
    const timerInterval = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timerInterval);
          clearInterval(textInterval);

          setCurrentStep(2);

          saveSteps({
            stepInternal: 2,
            stepGeneral: 4,
            loading: false,
          });

          setViewButton(true);

          return 0;
        }

        return prev - 1;
      });
    }, 1000);

    return () => {
      clearInterval(textInterval);
      clearInterval(timerInterval);
    };
  }, [veriffStatus, INITIAL_TIME, saveSteps, texts.length]);

  useEffect(() => {
    localStorage.setItem(TIMER_KEY, String(timeLeft));
  }, [timeLeft]);

  useEffect(() => {
    loadOfertCredit();
    loadUser();
  }, [loadOfertCredit, loadUser]);

  useEffect(() => {
    const checkIfMobile = () => {
      setIsDesktopReize(window.innerWidth >= 1000 && window.innerHeight >= 945);
    };

    checkIfMobile();
    window.addEventListener("resize", checkIfMobile);

    return () => window.removeEventListener("resize", checkIfMobile);
  }, []);

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <div className="space-y-6 flex flex-col items-center">
            {veriffStatus !== "PENDING" ? (
              <>
                {!isDesktop ? (
                  <div>
                    <p className="text-muted-foreground font-bold2 text-2xl flex flex-col items-center">
                      Verifica tu identidad
                      <img src="/png/veriff-logo.png" style={{width: "300px", height: "150px"}} />
                      {/* <img src="/png/veriff-logo.png" className="w-96 h-52" alt="Veriff" /> */}
                    </p>

                    <div className="flex flex-col gap-4">
                      <div
                        className="
                    w-full
                    flex
                    items-center
                    gap-5
                    rounded-3xl
                    border
                    border-white/10
                    bg-[#3B3562]
                    px-4
                    py-4
                    transition-all
                    duration-200
                    hover:bg-[#463E72]
                    hover:border-violet-400/30
                  "
                      >
                        <div
                          className="
                      flex
                      h-16
                      w-32
                      items-center
                      justify-center
                      rounded-2xl
                      bg-[#5A2D91]
                    "
                        >
                          <IdCard
                            size={30}
                            className="text-white"
                            strokeWidth={2}
                          />
                        </div>

                        <div className="text-left">
                          <h3 className="text-xl font-semibold2 text-white">
                            {"Cédula de ciudadania"}
                          </h3>

                          <p className="mt-1 text-base font-semibold2 leading-6 text-white">
                            {
                              "Recuerda tener tu documento fisico para validar la identidad"
                            }
                          </p>
                        </div>
                      </div>
                      <div
                        className="
                    w-full
                    flex
                    items-center
                    gap-5
                    rounded-3xl
                    border
                    border-white/10
                    bg-[#3B3562]
                    px-4
                    py-4
                    transition-all
                    duration-200
                    hover:bg-[#463E72]
                    hover:border-violet-400/30
                  "
                      >
                        <div
                          className="
                      flex
                      h-16
                      w-32
                      items-center
                      justify-center
                      rounded-2xl
                      bg-[#5A2D91]
                    "
                        >
                          <Camera
                            size={30}
                            className="text-white"
                            strokeWidth={2}
                          />
                        </div>

                        <div className="text-left">
                          <h3 className="text-xl font-semibold2 text-white">
                            {"Camara"}
                          </h3>
                          <p className="mt-1 text-base font-semibold2 leading-6 text-white">
                            {
                              "Asegurate de estar en un lugar con buena iluminación natural."
                            }
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    <img
                      src="/png/veriff-logo.png"
                      className={getFormHeightAndWidth()}
                      alt="Veriff"
                    />

                    <div className="flex gap-4 m-0">
                      <div
                        className="
                    w-full
                    flex
                    items-center
                    gap-5
                    rounded-3xl
                    border
                    border-white/10
                    bg-[#3B3562]
                    px-4
                    py-4
                    transition-all
                    duration-200
                    hover:bg-[#463E72]
                    hover:border-violet-400/30
                  "
                      >
                        <div
                          className="
                      flex
                      h-16
                      w-16
                      items-center
                      justify-center
                      rounded-2xl
                      bg-[#5A2D91]
                    "
                        >
                          <IdCard
                            size={30}
                            className="text-white"
                            strokeWidth={2}
                          />
                        </div>

                        <div className="text-left">
                          <h3 className="text-xl font-semibold2 text-white">
                            {"Cédula de ciudadania"}
                          </h3>

                          <p className="mt-1 text-base font-semibold2 leading-6 text-white">
                            {
                              "Recuerda tener tu documento fisico para validar la identidad"
                            }
                          </p>
                        </div>
                      </div>
                      <div
                        className="
                    w-full
                    flex
                    items-center
                    gap-5
                    rounded-3xl
                    border
                    border-white/10
                    bg-[#3B3562]
                    px-4
                    py-4
                    transition-all
                    duration-200
                    hover:bg-[#463E72]
                    hover:border-violet-400/30
                  "
                      >
                        <div
                          className="
                      flex
                      h-16
                      w-16
                      items-center
                      justify-center
                      rounded-2xl
                      bg-[#5A2D91]
                    "
                        >
                          <Camera
                            size={30}
                            className="text-white"
                            strokeWidth={2}
                          />
                        </div>

                        <div className="text-left">
                          <h3 className="text-xl font-semibold2 text-white">
                            {"Camara"}
                          </h3>

                          <p className="mt-1 text-base font-semibold2 leading-6 text-white">
                            {
                              "Asegurate de estar en un lugar con buena iluminación natural."
                            }
                          </p>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </>
            ) : (
              <>
                <div className="pb-6 md:mb-0 lg:mx-0">
                  {/* PENDING STATE */}
                  {veriffStatus === "PENDING" && (
                    <div className="py-4 flex flex-col items-center">
                      <div
                        style={{
                          fontSize: "clamp(26px, 4vw, 36px)",
                          fontWeight: 700,
                          color: "#ffffff",
                          fontVariantNumeric: "tabular-nums",
                        }}
                      >
                        ⏱ {formatTime(timeLeft)}
                      </div>

                      <div className="flex flex-col items-center justify-center py-6">
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "-webkit-fill-available",
                          }}
                        >
                          <AnimationComponent
                            animationUrl="/animations/solicitudNave.riv"
                            width={
                              isMobile
                                ? "clamp(20rem,25vw,30rem)"
                                : "clamp(15rem, 15vw, 30rem)"
                            }
                            height={getHeight()}
                            heightContainer={getContainerHeight()}
                            isDesktop={!isMobile}
                            stateMachines={["machineSolicitud"]}
                          />
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          overflow: "auto",
                        }}
                      >
                        <span
                          style={{
                            textAlign: "center",
                            width: isMobile && "400px",
                            fontSize: "clamp(20px, 3vh, 25px)",
                            display: "inline-block",
                            animation: "fadeText 3s ease-in-out infinite",
                          }}
                        >
                          {texts[textIndex]}
                        </span>
                      </div>
                    </div>
                  )}

                  {/* TIMEOUT STATE */}
                  {/* {veriffStatus === "TIMEOUT" && (
                <div className="py-4">
                  <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-blue-50 mb-6">
                    <svg
                      className="h-8 w-8 text-blue-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </div>
                  <h2 className="text-2xl font-bold mb-4 text-tdark">
                    Tu verificación está en proceso
                  </h2>
                  <p className="text-grayP mb-8">
                    El análisis de seguridad está tomando un poco más de tiempo
                    de lo habitual. No te preocupes, no necesitas esperar aquí.
                    Te notificaremos en cuanto finalice el proceso.
                  </p>
                  <button
                    onClick={() => navigate("/perfil")}
                    className="w-full py-4 px-6 bg-darkBg text-white rounded-xl font-bold text-lg hover:bg-darkBg/90 transition duration-300 shadow-md cursor-pointer"
                  >
                    Entendido, ir al Perfil
                  </button>
                </div>
              )} */}

                  {/* DECLINED / FAILED STATE */}
                  {/* {veriffStatus === "DECLINED" && (
                <div className="py-4">
                  <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 mb-6">
                    <svg
                      className="h-10 w-10 text-red-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                      />
                    </svg>
                  </div>
                  <h2 className="text-2xl font-bold mb-4 text-red-600">
                    Verificación Rechazada
                  </h2>
                  <div className="bg-red-50 text-red-700 rounded-xl p-4 mb-8 text-sm border border-red-100 max-w-md mx-auto">
                    <p className="font-semibold mb-1">Razón del rechazo:</p>
                    <p>{reason}</p>
                  </div>
                  <div className="flex flex-col gap-4">
                    <button
                      onClick={handleStartVerification}
                      className="w-full py-4 px-6 bg-darkBg text-white rounded-xl font-bold text-lg hover:bg-darkBg/90 transition duration-300 shadow-md cursor-pointer"
                    >
                      Volver a intentar
                    </button>
                    <button
                      onClick={() => navigate("/perfil")}
                      className="text-sm text-grayP hover:text-tdark underline cursor-pointer"
                    >
                      Ir al Perfil
                    </button>
                  </div>
                </div>
              )} */}
                </div>
              </>
            )}
          </div>
        );
      case 2:
        return (
          <div className="space-y-6 flex flex-col items-center h-full" style={{ width: isDesktop && "348px" }}>
            {!isDesktop && (
              <div className="text-center mb-6" style={{ width: "300px" }}>
                <p className="text-muted-foreground font-bold2 text-2xl">
                  Te enviamos el código OTP a tu WhatsApp.
                </p>
              </div>
            )}
            <div
              style={{ width: !isDesktop && "100%", display: !isDesktop && "flex", justifyContent: !isDesktop && "space-evenly" }}>
              <OtpComponente
                name="otp"
                id="otp"
                value={formDataOtp.otp}
                onChange={handleInputChange}
                isDesktop={isDesktop}
              ></OtpComponente>
            </div>
            {!isDesktop && (
              <div className="text-center" style={{ width: "310px" }}>
                <p
                  className="text-muted-foreground"
                  style={{
                    fontSize: "16px",
                  }}
                >
                  Escribe el código de ó dígitos que te envíamos a tu WhatsApp
                  registrado +57{celularProtect}
                </p>
              </div>
            )}
            {viewProgress ? (
              <Fragment>
                <ProgressLinear></ProgressLinear>
                <p style={{ fontSize: 13 }}>
                  Estamos validando tu código, por favor espera...
                </p>
              </Fragment>
            ) : (
              <Fragment>
                <button
                  onClick={() => {
                    trackEvent("otp_reenviado", { contexto: "firma" });
                    resendCodeSignature();
                  }}
                  type="button"
                  style={{
                    height: isDesktop ? "56px" : "50px",
                    backgroundColor: disableButton ? "#29214F" : "#565584",
                    borderRadius: "50px",
                    opacity: disableButton ? 0.5 : 1,
                    cursor: disableButton ? "not-allowed" : "pointer",
                    border: disableButton ? "2px solid #687099" : "none",
                    width: isDesktop && "300px",
                    fontSize: isDesktop ? "18px" : "22px",
                  }}
                  disabled={disableButton}
                  className={`flex w-full items-center rounded-xl justify-center gap-3 px-4 py-3 transition-all duration-200 font-medium shadow-xl text-base sm:text-xl`}
                >
                  <KeyIcon className="w-7 h-7" style={{ color: "#C9B8FF" }} />
                  <p style={{ color: "#C9B8FF" }}>Reenviar Código</p>
                </button>
              </Fragment>
            )}
            <button
              onClick={() => handleToggleDialogContratoFirma()}
              type="button"
              style={{
                height: isDesktop ? "56px" : "50px",
                backgroundColor: "#565584",
                borderRadius: "50px",
                width: isDesktop && "300px",
                fontSize: isDesktop ? "18px" : "22px",
                cursor: "pointer",
              }}
              className={`flex w-full items-center rounded-xl justify-center gap-3 px-4 py-3 transition-all duration-200 font-medium shadow-xl text-base sm:text-xl`}
            >
              <FilesIcon className="w-7 h-7" style={{ color: "#C9B8FF" }} />
              <p style={{ color: "#C9B8FF", cursor: "pointer" }}>
                Contrato firma Electrónica
              </p>
            </button>
            <BottomSheet
              open={dialogOpenContratoFirma}
              onOpenChange={setDialogOpenContratoFirma}
              isDesktop={isDesktop}
              headerContent={<h2>Contrato Firma Electronica</h2>}
            >
              <div className="space-y-3 w-full">
                <div
                  className="h-full rounded-t-3xl overflow-auto"
                  style={{
                    backgroundColor: "#2C2447",
                    color: "#FAFAFA",
                  }}
                >
                  <ContractFirmaElectronicaV3
                    basicInfo={creditUserStore}
                    userinfo={offerCreditStore}
                  />
                </div>
              </div>
            </BottomSheet>
          </div>
        );

      default:
        return null;
    }
  };

  if (isApprovedVeriff) {
    return (
      <Fragment>
        <div
          className="fixed inset-0 flex items-center justify-center min-h-screen w-full z-50"
          style={{
            color: "white",
            overflow: "hidden",
          }}
        >
          {/* Logo superior izquierda - solo desktop */}
          {isDesktop && (
            <div
              style={{
                backgroundColor: "#29214F",
                borderTopRightRadius: "50px",
                borderBottomRightRadius: "50px",
                width: "187px",
                height: "62px",
                position: "absolute",
                left: 0,
                top: 40,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                padding: "6px 20px 6px 0px",
              }}
            >
              <GalileIcon alt="Galilea" />
            </div>
          )}

          {/* Texto lateral izquierdo - solo desktop */}
          {isDesktop && (
            <div
              class="z-20 flex flex-col md:flex-row items-center justify-center gap-2.5 text-[#ffffff]/70 pointer-events-none select-none tracking-widest uppercase font-light text-[10px] text-center my-6 md:my-0 md:fixed md:w-auto md:left-[-290px] md:top-[50%] md:-translate-y-1/2 md:-rotate-90 md:origin-center">
              <div class="flex flex-row items-center justify-center gap-4 mr-2">
                <div class="flex items-center md:border-r border-[#ffffff]/30 pr-4 shrink-0 capitalize">
                  <img src="https://galilea.co/png/colombia-fintech.png" class="h-8 w-auto object-contain"
                    alt="colombia fintech" />
                </div>

                <div class="flex items-center md:border-r border-[#ffffff]/30 md:pr-4 shrink-0">
                  <img src="https://galilea.co/png/sic.png" class="h-6 w-auto object-contain brightness-0 invert opacity-90"
                    alt="Superintendencia de Industria y Comercio" />
                </div>
              </div>
              <span
                class="normal-case text-[11px] leading-tight tracking-normal text-[#ffffff]/70 max-w-[280px] md:max-w-[340px] font-semibold2">
                Galilea es una marca de GRUPO EMPRESARIAL ANAV S.A.S GEAA <br class="hidden md:inline" />registrada en
                Colombia con NIT: 901.582.748-5
              </span>

            </div>
          )}

          {/* Contenedor principal centrado */}
          {isDesktop ? (
            <div
              style={{
                width: "-webkit-fill-available",
                height: "-webkit-fill-available",
                backgroundColor: "#29214F",
                left: 390,
                top: "clamp(150px, 6vw, 200px)",
                position: "absolute",
                borderRadius: "30px",
                marginRight: "107px",
                marginBottom: "clamp(50px, 3vw, 80px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div className="flex flex-col items-center justify-center">
                {/* Componente de animación Rive */}
                <h1
                  className="font-bold2"
                  style={{
                    fontSize: "2rem",
                    width: "300px",
                    textAlign: "center",
                  }}
                >
                  ¡Luz Púrpura para Continuar!
                </h1>
                <AnimationComponent
                  animationUrl="/animations/checkanimation.riv"
                  width={"40vw"}
                  height={"40vh"}
                  isDesktop={isDesktop}
                  stateMachines={["chek-animation"]}
                />
                <p
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    width: "200px",
                  }}
                >
                  <span>
                    ¡<span style={{ color: "#A68AFF" }}>Felicitaciones</span>!
                  </span>
                  <span
                    style={{
                      textAlign: "center",
                    }}
                  >
                    Has completado la verificación de tu identidad.
                  </span>
                </p>
              </div>
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center">
              {/* Componente de animación Rive */}
              <h1
                className="font-bold2"
                style={{
                  fontSize: "2rem",
                  width: "300px",
                  textAlign: "center",
                }}
              >
                ¡Luz Púrpura para Continuar!
              </h1>
              <AnimationComponent
                animationUrl="/animations/checkanimation.riv"
                width={"20rem"}
                height={"40rem"}
                heightContainer={"25rem"}
                isDesktop={isDesktop}
                stateMachines={["chek-animation"]}
              />
              <p
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  width: "200px",
                }}
              >
                <span>
                  ¡<span style={{ color: "#A68AFF" }}>Felicitaciones</span>!
                </span>
                <span
                  style={{
                    textAlign: "center",
                  }}
                >
                  Has completado la verificación de tu identidad.
                </span>
              </p>
            </div>
          )}
        </div>
      </Fragment>
    );
  }

  if (isNotApprovedVeriff) {
    return (
      <Fragment>
        <div
          className="fixed inset-0 flex items-center justify-center min-h-screen w-full"
          style={{
            color: "white",
            overflow: "hidden",
            zIndex: 99,
          }}
        >
          {/* Logo superior izquierda - solo desktop */}
          {isDesktop && (
            <div
              style={{
                backgroundColor: "#29214F",
                borderTopRightRadius: "50px",
                borderBottomRightRadius: "50px",
                width: "187px",
                height: "62px",
                position: "absolute",
                left: 0,
                top: 40,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                padding: "6px 20px 6px 0px",
              }}
            >
              <GalileIcon
                alt="Galilea"
              /*  onClick={() => {
              navigate("/");
            }} */
              />
            </div>
          )}
          {/* Texto lateral izquierdo - solo desktop */}
          {isDesktop && (
            <div
              class="z-20 flex flex-col md:flex-row items-center justify-center gap-2.5 text-[#ffffff]/70 pointer-events-none select-none tracking-widest uppercase font-light text-[10px] text-center my-6 md:my-0 md:fixed md:w-auto md:left-[-290px] md:top-[50%] md:-translate-y-1/2 md:-rotate-90 md:origin-center">
              <div class="flex flex-row items-center justify-center gap-4 mr-2">
                <div class="flex items-center md:border-r border-[#ffffff]/30 pr-4 shrink-0 capitalize">
                  <img src="https://galilea.co/png/colombia-fintech.png" class="h-8 w-auto object-contain"
                    alt="colombia fintech" />
                </div>

                <div class="flex items-center md:border-r border-[#ffffff]/30 md:pr-4 shrink-0">
                  <img src="https://galilea.co/png/sic.png" class="h-6 w-auto object-contain brightness-0 invert opacity-90"
                    alt="Superintendencia de Industria y Comercio" />
                </div>
              </div>
              <span
                class="normal-case text-[11px] leading-tight tracking-normal text-[#ffffff]/70 max-w-[280px] md:max-w-[340px] font-semibold2">
                Galilea es una marca de GRUPO EMPRESARIAL ANAV S.A.S GEAA <br class="hidden md:inline" />registrada en
                Colombia con NIT: 901.582.748-5
              </span>

            </div>
          )}

          {/* Contenedor principal centrado */}
          {isDesktop ? (
            <div
              className="flex flex-col items-center justify-between"
              style={{
                height: "-webkit-fill-available",
                margin: "20px 0px 20px 0px",
              }}
            >
              {/* Componente de animación Rive */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "space-around",
                  height: "-webkit-fill-available",
                }}
              >
                <AnimationComponent
                  animationUrl="/animations/panel_nave.riv"
                  width={isDesktopReize ? "67rem" : "30rem"}
                  height={isDesktopReize ? "45rem" : "20rem"}
                  heightContainer={isDesktopReize ? "28rem" : "20rem"}
                  isDesktop={isDesktop}
                  stateMachines={["panel-rocket"]}
                />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "10px",
                    overflow: "auto",
                  }}
                >
                  <span
                    className="font-bold2"
                    style={{
                      color: "#A68AFF",
                      fontSize: " 25px",
                      width: "250px",
                      textAlign: "center",
                    }}
                  >
                    ¡Cambiamos la ruta de tu viaje!
                  </span>
                  <div
                    style={{
                      overflow: "auto",
                      display: "flex",
                      flexDirection: "column",
                      gap: "25px",
                    }}
                  >
                    <span style={{ textAlign: "center", width: "400px" }}>
                      Esta vía no fue aprobada; te sugerimos cuidar tu historial
                      crediticio y tu capacidad de endeudamiento.
                    </span>

                    <span
                      className="font-bold2"
                      style={{ textAlign: "center", width: "400px" }}
                    >
                      ¡Tranquilo!, Nuestro aliado te puede ofrecer hasta
                      $1.500.000 ¡solicítalo ahora!.
                    </span>
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  width: "-webkit-fill-available",
                  margin: "0px 46px",
                  gap: "20px",
                }}
              >
                <span
                  className="font-bold2"
                  style={{
                    textAlign: "center",
                    width: "200px",
                    fontSize: "35px",
                    color: "#1CC995",
                  }}
                >
                  CREZU
                </span>
                <button
                  data-aliado="crezu"
                  type="button"
                  onClick={() => {
                    window.open(url, "_blank", "noopener,noreferrer");
                    cleanIndexDB();
                    navigate("/");
                  }}
                  style={{
                    height: "70px",
                    borderRadius: "2.5rem",
                    fontSize: "1.2rem",
                    fontWeight: "400",
                    cursor: "pointer",
                    backgroundColor: "#7E02FC",
                    width: "400px",
                    margin: "0px",
                  }}
                  className={`flex items-center justify-center gap-3 px-4 py-3 transition-all duration-200 flex-1 font-medium text-base text-white `}
                >
                  <p style={{ fontSize: "1.3rem" }}>Acceder al crédito</p>
                  <ArrowRightIcon className="w-8 h-8" />
                </button>
              </div>
            </div>
          ) : (
            <div
              className="flex flex-col items-center justify-between"
              style={{
                height: "-webkit-fill-available",
                margin: "20px 0px",
              }}
            >
              {/* Componente de animación Rive */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "space-around",
                  height: "-webkit-fill-available",
                  overflow: "auto",
                }}
              >
                <AnimationComponent
                  animationUrl="/animations/panel_nave.riv"
                  width={"28rem"}
                  height={"40rem"}
                  heightContainer={"19rem"}
                  isDesktop={isDesktop}
                  stateMachines={["panel-rocket"]}
                />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    width: "-webkit-fill-available",
                    margin: "0px 56px",
                    gap: "20px",
                  }}
                >
                  <span
                    className="font-bold2"
                    style={{
                      textAlign: "center",
                      width: "200px",
                      fontSize: "35px",
                      color: "#1CC995",
                    }}
                  >
                    CREZU
                  </span>
                  <button
                    data-aliado="crezu"
                    type="button"
                    onClick={() => {
                      window.open(url, "_blank", "noopener,noreferrer");
                      cleanIndexDB();
                      navigate("/");
                    }}
                    style={{
                      height: "70px",
                      borderRadius: "2.5rem",
                      fontSize: "1.2rem",
                      fontWeight: "400",
                      cursor: "pointer",
                      backgroundColor: "#7E02FC",
                      width: "-webkit-fill-available",
                      margin: "0px",
                    }}
                    className={`flex items-center justify-center gap-3 px-4 py-3 transition-all duration-200 flex-1 font-medium text-base text-white `}
                  >
                    <p style={{ fontSize: "1.3rem" }}>Acceder al crédito</p>
                    <ArrowRightIcon className="w-8 h-8" />
                  </button>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "25px",
                    overflow: "auto",
                  }}
                >
                  <span
                    className="font-bold2"
                    style={{
                      color: "#A68AFF",
                      fontSize: " 25px",
                      width: "250px",
                      textAlign: "center",
                    }}
                  >
                    ¡Cambiamos la ruta de tu viaje!
                  </span>
                  <div
                    style={{
                      overflow: "visible",
                      display: "flex",
                      flexDirection: "column",
                      gap: "25px",
                    }}
                  >
                    <span style={{ textAlign: "center", width: "300px" }}>
                      Esta vía no fue aprobada; te sugerimos cuidar tu historial
                      crediticio y tu capacidad de endeudamiento.
                    </span>
                    <span
                      className="font-bold2"
                      style={{ textAlign: "center", width: "300px" }}
                    >
                      ¡Tranquilo!, Nuestro aliado te puede ofrecer hasta
                      $1.500.000 ¡solicítalo ahora!.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </Fragment>
    );
  }

  return (
    <Fragment>
      {alertSession && (
        <>
          <WarningAlert
            isOpen={isOpenWarning}
            message={messsageAlert}
            isDesktop={isDesktop}
          ></WarningAlert>
          <ErrorAlert
            isOpen={isOpenError}
            message={messsageAlert}
            isDesktop={isDesktop}
          ></ErrorAlert>

          <InfoAlert
            isOpen={isOpenInfo}
            message={messsageAlert}
            isDesktop={isDesktop}
          ></InfoAlert>
        </>
      )}
      <div className="w-full h-full">
        <StepContainer
          onNext={handleNext}
          onPrev={handlePrev}
          canGoNext={viewButton}
          canGoPrev={false}
          errors={isError}
          disabled={isDisabled}
          isLastStep={currentStep === totalSteps}
          isLoading={isLoading}
          isDesktop={isDesktop}
          nextText={currentText}
          title={stepTitles[currentStep - 1]}
          subtitle={stepSubTitles[currentStep - 1]}
          finishText="Firmar"
        >
          <div
            className={`transition-all duration-300 ease-in-out ${isTransitioning
              ? "opacity-0 transform translate-x-4"
              : "opacity-100 transform translate-x-0"
              }`}
            style={{
              width: "-webkit-fill-available",
              overflowY: "auto",
              height: isDesktop ? "-webkit-fill-available" : getFormHeight(),
              display: isDesktop && "flex",
              justifyContent: isDesktop && "center",
            }}
          >
            {!isDesktop && (
              <div className="mb-4 text-center flex flex-col items-center">
                <div className="text-sm" style={{ color: "#c8cbda" }}>
                  Paso {currentStepGeneral} de {stepTitlesGeneral.length}
                </div>
                <div className="mt-1" style={{ fontSize: 16 }}>
                  {currentStep && stepTitles[currentStep - 1]}
                </div>
              </div>
            )}
            {renderStep()}
          </div>
        </StepContainer>
      </div>
    </Fragment>
  );
};

export default DatosOtp;
